import { render } from "./StopPointRoute.vue?vue&type=template&id=0f174484&style=position%3A%20relative%3B"
import script from "./StopPointRoute.vue?vue&type=script&lang=ts"
export * from "./StopPointRoute.vue?vue&type=script&lang=ts"
script.render = render

export default script